import Swal from "sweetalert2";

export const handleGeneratePdfApiError = (error, t, options = {}) => {
    const { addSummary, setRxMeetingId } = options;

  const message = error?.response?.data?.message || error.message;

  // Handle summary condition
    if (message === "No summary. Please sign again" && typeof addSummary === "function") {
        addSummary();
  }

  // Set meetingId only if function exists
  if (typeof setRxMeetingId === "function") {
    setRxMeetingId(error?.response?.data?.meetingId);
  }

  // Show alert
  Swal.fire({
    icon: "error",
    title: t("Error"),
    text: t(message),
    allowOutsideClick: false,
    customClass: {
      popup: "swal2-front",
      htmlContainer: "my-swal-text",
      confirmButton: "my-swal-button",
    },
  });
};
